import React, { useState } from 'react';
import './VoiceConfirmation.css';
import MicIcon from '@mui/icons-material/Mic';
import { Box, Dialog, DialogActions, DialogContent, IconButton, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { showToast } from '../Toast/CommonToast';
import CheckIcon from '@mui/icons-material/Check';
import ReusableButton from '../Reusable/PrimaryButton/PrimaryButton';

interface VoiceConfirmationProps {
  credits?: number;
  onConfirm?: (confirmed: boolean) => void;
  confimationVoicePopup?: boolean
  setVoicePopupOpen?: any
  voicePopupOpen?: any
  setConfimationnVoicePopup?:any
  modelName?:string,
  insertedId?:string
  setInstructionPopupOpen?:any
  setVoiceConfirm?: (value: 'yes' | 'no') => void
}

const VoiceConfirmation: React.FC<VoiceConfirmationProps> = ({ 
  credits = 450, 
  onConfirm,
  confimationVoicePopup,
  setVoicePopupOpen,
  setConfimationnVoicePopup,
  modelName,
  insertedId,
  setInstructionPopupOpen,
  setVoiceConfirm
}) => {
  console.log("insertedId", insertedId)
  const [selectedOption, setSelectedOption] = useState<'yes' | 'no'>("no");

  const handleOptionChange = (value: 'yes' | 'no') => {
    if(modelName){
      setSelectedOption(value);
      if (setVoiceConfirm) {
        setVoiceConfirm(value);
      }
      if (onConfirm) {
        onConfirm(value === 'yes');
      }
    } else {
      showToast('please create a model', 'error');
    }
  };

  const onClose = ()=>{
    setConfimationnVoicePopup(false)
  }

  return (
    <div className="voice-confirmation-container">
      <div className="voice-confirmation-icon">
        <MicIcon  />
      </div>

      <div className="voice-confirmation-content">
        <h2 className="voice-confirmation-title">
          Do you want to personalize by adding your own voice in the next step?
        </h2>
        <p className="voice-confirmation-subtitle">
          Please confirm if you want to add after creating your model using{' '}
          <span className="voice-confirmation-credits">{credits} credits.</span>
        </p>

        <div className="voice-confirmation-options">
          <label className="voice-option-label">
            <input
              type="radio"
              name="voiceConfirm"
              value="yes"
              checked={selectedOption === 'yes'}
              onChange={(e) => handleOptionChange(e.target.value as 'yes' | 'no')}
              className="voice-option-input"
            />
            <div className={`voice-radio-button ${selectedOption === 'yes' ? 'selected' : ''}`}>
              <div className="voice-radio-inner" />
            </div>
            <span className="voice-option-text">Yes</span>
          </label>

          <label className="voice-option-label">
            <input
              type="radio"
              name="voiceConfirm"
              value="no"
              checked={selectedOption === 'no'}
              onChange={(e) => handleOptionChange(e.target.value as 'yes' | 'no')}
              className="voice-option-input"
            />
            <div className={`voice-radio-button ${selectedOption === 'no' ? 'selected' : ''}`}>
              <div className="voice-radio-inner" />
            </div>
            <span className="voice-option-text">No</span>
          </label>
        </div>
      </div>
      {confimationVoicePopup && (
       <Dialog 
      open={confimationVoicePopup} 
      onClose={(event, reason) => {
        if (reason !== "backdropClick") {
          onClose();
        }
      }}
      maxWidth="md" 
      fullWidth
      PaperProps={{
        sx: {
          backgroundColor: '#3d4466',
          borderRadius: 3,
          maxWidth: 900,
        }
      }}
    >
      {/* Header */}
      <Box sx={{ 
        display: 'flex', 
        justifyContent: 'space-between', 
        alignItems: 'center',
        p: 2,
        borderBottom: '1px solid rgba(255, 255, 255, 0.1)'
      }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <CheckIcon sx={{ color: '#fff' }} />
         <Typography sx={{ color: '#fff', fontSize: 18, fontWeight: 500 }}>
  Persona Created
</Typography>
        </Box>
        <Box sx={{ display: 'flex', gap: 2, alignItems: 'center' }}>
          
          <IconButton onClick={onClose} sx={{ color: '#fff' }}>
            <CloseIcon />
          </IconButton>
        </Box>
      </Box>
      {/* content */}
      <DialogContent sx={{textAlign: 'center'}}>
        <img src={'/assets/attention.svg'} />
        <Typography sx={{ color: '#fff', fontSize: 18, fontWeight: 500 }}>
  {modelName && `Persona ${modelName} has been created successfully`}
</Typography>
<Typography sx={{
            color: '#a8b0d3',
            fontSize: 14,
          }}>
  Please proceed to next step to add personalized voice`
</Typography>
      </DialogContent>
      <DialogActions sx={{justifyContent: 'center', mb: 8}}>
        <ReusableButton
        onClick={()=>{
          setInstructionPopupOpen(true)
          setConfimationnVoicePopup(false)
        }}
        >
          Continue
        </ReusableButton>
      </DialogActions>
    </Dialog>
      )}
    </div>
  );
};

export default VoiceConfirmation;